import { render, staticRenderFns } from "./OrdersSingle.vue?vue&type=template&id=748d66f9&"
import script from "./OrdersSingle.vue?vue&type=script&lang=js&"
export * from "./OrdersSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports